import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import RichTextEditor from 'react-rte';
import { useParams } from "react-router";
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from "../Breadcrumb/Breadcrumb"
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/colors/red.css"; // Optional: Theme
import Trash from "../../Assets/images/recycle-bin.png";
import Plus from "../../Assets/images/plus.png";

const AddOffer = () => {

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    offer_title:'',
    coupon_code: '',
    start_date: '',
    end_date: '',
    discount_percentage: '',
    discount_upto_price: '',
    offer_details: []
  });
  const { organization } = useContext(OrganizationContext);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [areas, setAreas] = useState([]);
  const [file, setFile] = useState(null);
  const [editorState, setEditorState] = useState(RichTextEditor.createEmptyValue());
  const [selectedDates, setSelectedDates] = useState([]);
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [duration, setDuration] = useState("");
  const [timeSlots, setTimeSlots] = useState([]);
  const [offerDetails, setOfferDetails] = useState([{ id: Date.now(), detail: '' }]);

  // errors
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let errors = {};
    if (!formData.offer_title) errors.offer_title = "offer title is required";
    if (!formData.coupon_code) errors.coupon_code = "Coupon code is required";
    if (!formData.discount_percentage) errors.discount_percentage = "Discount percentage is required";
    if (!formData.discount_upto_price) errors.discount_upto_price = "Discount upto price is required";
    if (!formData.start_date) errors.start_date = "Start date is required";
    if (!formData.end_date) errors.end_date = "End date is required";

    // Validate Offer Details
    let offerDetailErrors = offerDetails.map((detail, index) =>
      !detail.detail ? `Offer detail ${index + 1} is required` : ""
    );

    if (offerDetailErrors.some(error => error !== "")) {
      errors.offer_details = offerDetailErrors;
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handlesubmit = (event) => {
    event.preventDefault(); // Prevent default form submission
    if (!validateForm()) return;
    const token = authService.getCurrentadmin().token;
    const requestData = {
      organization_id: organization,
      coupon_code: formData.coupon_code,
      discount_percentage: formData.discount_percentage,
      discount_upto_price: formData.discount_upto_price,
      start_date: formData.start_date,
      end_date: formData.end_date,
      offer_details: offerDetails.map(detail => ({ details: detail.detail })), 
      logo:'',
      is_active: "A",
      offer_title: formData.offer_title,
    };

    fetch(authService.getApiUrl() + 'offers', {
      method: 'POST',
      body: JSON.stringify(requestData),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        navigate(`/admin/offers`);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: name === "coupon_code" ? value.toUpperCase() : (type === 'checkbox' ? checked : value),
      //[name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleDetailChange = (id, value) => {
    setOfferDetails(offerDetails.map(detail => detail.id === id ? { ...detail, detail: value } : detail));
  };

  const handleAddDetail = () => {
    setOfferDetails([...offerDetails, { id: Date.now(), detail: '' }]);
  };

  const handleRemoveDetail = (id) => {
    setOfferDetails(offerDetails.filter(detail => detail.id !== id));
  };

  const handleDateChange = (name, date) => {
    setFormData({
      ...formData,
      [name]: date ? date.format("YYYY-MM-DD") : "",  // Ensure it's stored as a string
    });
  };

  return (
    <div className='main-container'>
      <div className='container-fluid'>
        <Breadcrumb />
        <div className='category-table'>
          <div className='flex-cont add-cat'>
            <div className='heading'>
              <h3>Add Offer</h3>
            </div>
          </div>
          <div className="card">
            <div className="card-body custom-edit-service">
              <form className="needs-validation clearfix" onSubmit={handlesubmit} >
                <div className="addtest-fields mb-3">
                  <div className="flex-cont">

                  <div className="full-cont">
                      <div className="form-group">
                        <label>
                          Offer Title
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="offer_title"
                          id="offer_title"
                          // required
                          value={formData.offer_title}
                          onChange={handleInputChange}
                        />
                        {errors.offer_title && <span className='errors' >{errors.offer_title}</span>}
                      </div>
                    </div>
                    <div className="full-cont">
                      <div className="form-group">
                        <label>
                          Coupon Code
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="coupon_code"
                          id="coupon_code"
                          // required
                          value={formData.coupon_code}
                          onChange={handleInputChange}
                        />
                        {errors.coupon_code && <span className='errors' >{errors.coupon_code}</span>}
                      </div>
                    </div>
                    <div className="half-cont">
                      <div className="form-group">
                        <label>
                          Discount in Percentage(%)
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="discount_percentage"
                          id="discount_percentage"
                          // required
                          value={formData.discount_percentage}
                          onChange={handleInputChange}
                        />
                        {errors.discount_percentage && <span className='errors' >{errors.discount_percentage}</span>}
                      </div>
                    </div>

                    <div className="half-cont">
                      <div className="form-group">
                        <label>
                          Discount Upto Price
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="discount_upto_price"
                          id="discount_upto_price"
                          // required
                          value={formData.discount_upto_price}
                          onChange={handleInputChange}
                        />
                        {errors.discount_upto_price && <span className='errors' >{errors.discount_upto_price}</span>}
                      </div>
                    </div>

                    <div className="half-cont">
                      <div className="form-group timeslot">
                        <label>
                          Valid From
                          <span className="text-danger">*</span>
                        </label>
                        <DatePicker
                          value={formData.start_date ? new Date(formData.start_date) : null}
                          onChange={(date) => handleDateChange("start_date", date)}
                          format="YYYY-MM-DD"
                          placeholder="Select date"
                          className="form-control"
                        />
                         {errors.start_date && <span className='errors' >{errors.start_date}</span>}
                      </div>
                    </div>

                    <div className="half-cont">
                      <div className="form-group timeslot">
                        <label>
                          Valid Upto
                          <span className="text-danger">*</span>
                        </label>
                        <DatePicker
                          value={formData.end_date ? new Date(formData.end_date) : null}
                          onChange={(date) => handleDateChange("end_date", date)}
                          format="YYYY-MM-DD"
                          placeholder="Select date"
                          className="form-control blue"
                        />

                        {errors.end_date && (<span className='errors'>{errors.end_date}</span>)}
                      </div>
                    </div>

                    <div className='heading'>
                      <h4>Terms & Conditions</h4>
                    </div>
                    {offerDetails.map((item, index) => (
                      <div className="full-cont">
                        <div className="addmoreset" key={item.id}>
                          <div className='addmore-offer'>
                            {/* <label>
                              details
                              <span className="text-danger">*</span>
                            </label> */}
                            <input
                              type="text"
                              value={item.detail}
                              onChange={(e) => handleDetailChange(item.id, e.target.value)}
                              className="form-control"
                              placeholder="Enter offer detail"
                            />


                          </div>

                          <div className="action-icon-add-delete">
                            <Button
                              type="text"
                              icon={<img src={Plus} alt="Add" style={{ width: 18, height: 18 }} />}
                              onClick={handleAddDetail}
                            />
                          </div>
                          <div className="action-icon-add-delete">
                            <Button
                              type="text"
                              icon={<img src={Trash} alt="Delete" style={{ width: 18, height: 18 }} />}
                              onClick={() => handleRemoveDetail(item.id)}
                              disabled={offerDetails.length === 1} // Prevent removing the last test
                            />
                          </div>
                        </div>
                        {errors.offer_details && errors.offer_details[index] && (
                          <span className='errors'>{errors.offer_details[index]}</span>
                        )}
                      </div>
                    ))}

                    {/* <div className="full-cont special-case-cont ">
                      <div className='form-group'>
                        <label className="custom-checkbox">
                          <input
                            type="checkbox"
                            name="is_active"
                            checked={formData.is_active}
                            onChange={handleInputChange}
                            value="A"
                          />
                          <span className="checkmark"></span>
                          <label>Status</label>
                        </label>
                      </div>
                    </div> */}

                  </div>
                </div>

                <div className="submit-section">

                  <button
                    className="btn btn-primary submit-btn"
                    type="submit"
                    name="form_submit"

                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOffer;
